/**
 * 火山方舟 Seedream 4 文生图（同步）：POST /images/generations
 * 与 Seedance 官方共用 Base URL 与 API Key（VUE_APP_OFFICIAL_VOLC_SEEDANCE_VIDEO_*）
 */
import axios from 'axios'
import { extractApiErrorMessage } from '../../extract-api-error-message'
import { proxifyVolcArkTosFetchUrl } from '../volc-ark-tos-fetch-url'

var IMAGES_PATH = '/images/generations'
var DEFAULT_MODEL = 'doubao-seedream-4-0-250828'
var SIZE_PRESETS = ['1K', '2K', '4K']

function downloadUrlToBlob(url) {
  var fetchUrl = proxifyVolcArkTosFetchUrl(url)
  return fetch(fetchUrl, fetchUrl.indexOf('/') === 0 ? {} : { mode: 'cors' })
    .then(function (res) {
      if (!res.ok) return Promise.reject(new Error('download image failed: HTTP ' + res.status))
      return res.blob()
    })
    .then(function (blob) {
      if (!blob || !blob.size) return Promise.reject(new Error('download image failed: empty blob'))
      return blob
    })
}

function getVolcArkConfig() {
  return {
    baseURL: (process.env.VUE_APP_OFFICIAL_VOLC_SEEDANCE_VIDEO_BASE_URL || '').replace(/\/$/, ''),
    apiKey: process.env.VUE_APP_OFFICIAL_VOLC_SEEDANCE_VIDEO_API_KEY || '',
    model: process.env.VUE_APP_OFFICIAL_VOLC_SEEDREAM_MODEL || DEFAULT_MODEL
  }
}

function normalizeSize(params) {
  var v = params.size || params.resolution
  if (!v || typeof v !== 'string') return '2K'
  var s = String(v).trim()
  if (SIZE_PRESETS.indexOf(s) !== -1) return s
  if (/^\d+x\d+$/.test(s)) return s
  return '2K'
}

/**
 * @param {Object} params - 与 AllAll Seedream 一致：prompt, size|resolution, addWatermark
 * @returns {Promise<{ urls: string[], provider: 'official', sync: true }>}
 */
export function submitVolcSeedream4Image(params) {
  var cfg = getVolcArkConfig()
  if (!cfg.baseURL) {
    return Promise.reject(new Error('未配置 VUE_APP_OFFICIAL_VOLC_SEEDANCE_VIDEO_BASE_URL'))
  }
  if (!cfg.apiKey) {
    return Promise.reject(new Error('未配置 VUE_APP_OFFICIAL_VOLC_SEEDANCE_VIDEO_API_KEY'))
  }
  var prompt = (params.prompt || '').trim()
  if (!prompt) {
    return Promise.reject(new Error('prompt 必填'))
  }
  var watermark =
    params.watermark !== undefined ? !!params.watermark : params.addWatermark !== false

  var body = {
    model: cfg.model,
    prompt: prompt,
    size: normalizeSize(params),
    watermark: watermark
  }

  return axios
    .post(cfg.baseURL.replace(/\/$/, '') + IMAGES_PATH, body, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + cfg.apiKey
      },
      timeout: 1800000
    })
    .then(function (res) {
      var data = res && res.data
      var list = (data && data.data) || []
      var urls = list.map(function (item) { return item && item.url }).filter(Boolean)
      if (!urls.length) {
        return Promise.reject(new Error('官方接口未返回图片 URL'))
      }
      return Promise.all(
        urls.map(function (u) {
          return downloadUrlToBlob(u)
        })
      )
        .then(function (blobs) {
          return { urls: urls, blobs: blobs, provider: 'official', sync: true }
        })
        .catch(function () {
          return { urls: urls, provider: 'official', sync: true }
        })
    })
    .catch(function (err) {
      var msg = extractApiErrorMessage(err.response && err.response.data) || err.message || '请求失败'
      return Promise.reject(new Error(msg))
    })
}
